var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 91,
    viewBox: "0 0 40 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2637 1.10971e-06V26.3517C31.5178 27.9022 25.7486 34.9504 25.7486 43.2911C25.7486 51.6315 31.5178 58.6795 39.2637 60.23V86.582C39.2636 86.582 39.2637 86.582 39.2637 86.582V60.23C31.5178 58.6795 25.7486 51.6315 25.7486 43.2911C25.7486 34.9504 31.5178 27.9022 39.2637 26.3517V1.10971e-06C39.2636 4.95363e-06 39.2637 -2.73438e-06 39.2637 1.10971e-06Z",
    fill: "#76DECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64209 43.2911C2.64209 64.4418 17.8296 81.7093 37.2637 84.3563V61.7927C29.3816 59.4538 23.7486 51.9724 23.7486 43.2911C23.7486 34.6095 29.3816 27.128 37.2637 24.7891V2.2257C17.8296 4.87266 2.64209 22.14 2.64209 43.2911Z",
    fill: "#76DECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.d5f7a964611267e89aab58e5f60f14f8.svg";
export { ForwardRef as ReactComponent };